import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function makeApi(getToken) {
  const instance = axios.create({ baseURL: API });
  instance.interceptors.request.use(async (cfg) => {
    const token = await getToken();
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
  });
  return instance;
}

const SAFE_MSG = {
  es: "¡Uy! Eso no es apropiado para Lumi & Spark. Prueba con otra idea divertida.",
  en: "Oops! That's not right for Lumi & Spark. Try another fun idea.",
};

const BUSY_MSG = {
  es: "Lumi y Spark están descansando un momento. Intenta otra vez en un ratito.",
  en: "Lumi and Spark are taking a short break. Try again in a moment.",
};

export const aiErrorText = (e, lang, fallback) => {
  const d = e?.response?.data?.detail;
  if (d === "not_kid_safe") return SAFE_MSG[lang] || SAFE_MSG.es;
  if (d === "moderation_unavailable") return BUSY_MSG[lang] || BUSY_MSG.es;
  if (d === "daily_text_limit") return lang === "en" ? "You used a lot of AI today! Come back tomorrow." : "¡Hoy usaste mucho la IA! Vuelve mañana.";
  if (d === "too_many_requests") return lang === "en" ? "Whoa, too fast! Wait a moment and try again." : "¡Uy, vas muy rápido! Espera un momentito y vuelve a intentar.";
  return fallback;
};

export const coinToast = (n, lang) => {
  if (!n) return;
  toast.success(lang === "en" ? `+${n} reward coins!` : `¡+${n} monedas de premio!`);
  window.dispatchEvent(new Event("coins-changed"));
};
